import React from 'react';
import { Link } from "react-router-dom";
import { Typography } from 'antd';
import { Card, Avatar, List, Form, Input, Button, Spin, Skeleton, notification, Popconfirm } from 'antd';
import { observer } from "mobx-react";
import { autorun } from 'mobx';

import { normalizeMatchPath, frontendProjectURL } from './common';

import { ProjectStoreContext } from './AppContexts';

@observer
class Projects extends React.Component {
	static contextType = ProjectStoreContext;

	componentDidMount() {
		if (this.context.items.length == 0){ //prevents re-fetching the store. You may want to use react-router-cache-route instead
			this.context.load();
		}
		this.refetchOnInsertDisposer = autorun( () => { //this code reloads the list when something is inserted
			console.log('check if needs refetching the store');
			if (this.context.dirty){
				this.context.load();
			}
		});
		console.log(this);
	}

	componentWillUnmount() {
		console.log('Projects componentWillUnmount');
		if (this.refetchOnInsertDisposer){
			this.refetchOnInsertDisposer();
		}
	}

	render() {
		console.log(this.props);
		return (
		<div>
			<Typography.Title level={3}>Projects</Typography.Title>
			<Typography.Paragraph className='text-right'>
				<Link to={`${normalizeMatchPath(this)}/projects/new`}><Button icon='plus' size='large' type='primary'>add project</Button></Link>
			</Typography.Paragraph>
			{ this.context.isLoading ?
				(
				<div>
					<Skeleton active paragraph={{ rows: 1 }} />
					<Skeleton active paragraph={{ rows: 1 }} />
					<Spin size="default" tip="Loading..." />
				</div>
				) : null }
			{ !this.context.isLoading && <div>ciao</div> }
		</div>
		)
	}
}

const ProjectDetailForm = Form.create({
	name: 'project-detail',
	onFieldsChange(props, changedFields) {
		props.onChange(changedFields);
	},
	mapPropsToFields(props) {
		//console.log(props);
		return {
			title: Form.createFormField({
				...props.title,
				value: props.title.value,
			}),
			description: Form.createFormField({
				...props.description,
				value: props.description.value,
			}),
			featureLayerURL: Form.createFormField({
				...props.featureLayerURL,
				value: props.featureLayerURL.value,
			}),
			vectorTileLayerURL: Form.createFormField({
				...props.vectorTileLayerURL,
				value: props.vectorTileLayerURL.value,
			}),
		};
	},
	/*onValuesChange(_, values) {
		console.log(values);
	},*/
})((props) => {
	const formItemLayout = {
		labelCol: {
			xs: { span: 24 },
			sm: { span: 8 },
		},
		wrapperCol: {
			xs: { span: 24 },
			sm: { span: 16 },
		},
	};
	const { getFieldDecorator } = props.form;

	let handleSubmit = (e) => {
		//console.log('internal handle submit');
		e.preventDefault();
		props.form.validateFieldsAndScroll((err, values) => {
			if (!err) {
				props.onSubmit(values);
			}
		});
	};

	return (
		<Form className='project-edit' {...formItemLayout} onSubmit={handleSubmit}>
			<Form.Item label='Title'>
			{ getFieldDecorator('title', {
				rules: [ { required: true, message: 'Please insert a title for this Project' }
				]
			})( <Input type="text" placeholder="Project title" />) }
			</Form.Item>
			<Form.Item label='Description'>
			{ getFieldDecorator('description', { })( <Input.TextArea rows={3} placeholder="Project description" />) }
			</Form.Item>
			<Form.Item label='Feature Layer URL'>
			{ getFieldDecorator('featureLayerURL', {
				rules: [ { type: 'url', message: 'The input is not a valid URL' }
					 ,{ required: true, message: 'Please insert an URL for this resource' }
				]
			})( <Input type="url" allowClear placeholder="https://..." onBlur={props.featureLayerURLBlur} />) }
			</Form.Item>
			<Form.Item label='Vector Tile Layer URL'>
			{ getFieldDecorator('vectorTileLayerURL', {
				rules: [ { type: 'url', message: 'The input is not a valid URL' }
					 ,{ required: true, message: 'Please insert an URL for this resource' }
				]
			})( <Input type="url" allowClear placeholder="https://..." />) }
			</Form.Item>
			<Form.Item label="Extent preview">
				{props.updateMapExtentButton}
				<span className="feature-extent-status">{!props.extent && props.featureLayerURL.value && !props.extentLoading ? 'invalid feature layer extent' : null }</span>
			</Form.Item>
			<Form.Item>
				<Button type="primary" htmlType="submit">Save</Button>
			</Form.Item>
			{ props.saving && <Spin size="small" tip="Saving..." /> }
		</Form>
	);
});

@observer
class ProjectDetail extends React.Component {
	static contextType = ProjectStoreContext;

	state = {
		loading: true
		,saving: false
		,fields: {
			title: { value: '' }
			,description: { value: '' }
			,featureLayerURL: { value: '' }
			,vectorTileLayerURL: { value: '' }
			,extent: { value: '' }
		}
		,id: this.props.match.params.id || null
	}

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		if (!this.state.id){
			this.setState({ loading: false });
			return;
		}
		this.context.fetchById(this.state.id).then( item => {
			console.log(item);
			let out = {};
			Object.keys(item).forEach( key => {
				out[key] = { value: item[key] };
			});
			this.setState(({ fields }) => ({
				fields: { ...fields, ...out }
				,id: item.id
			}));
			this.setState({ loading: false });
		});
	}

	handleFormChange = (changedFields) => {
		//console.log('handle form change', changedFields);
		this.setState(({ fields }) => ({
			fields: { ...fields, ...changedFields },
		}));
	}

	featureLayerURLBlur = () => {
		console.log('blur')
	}

	onExtentLoadFailed = (err) => {
		notification.error({
			message: 'Error',
			description: 'Cannot update the extent. Please check the Feature Layer URL',
			duration: 8
		});
	}

	refreshMapExtent = () => {
	}

	handleSubmit = (values) => {
		console.log('Received values of form: ', values);
		console.log(this.state);
		let promise = Promise.resolve();
		promise.then( () => {
		}).then( () => {
			console.log('saving...');
			this.setState({ saving: true });
			if (this.state.id){
				return this.context.update({
					...values
					,extent: this.featureLayerExtent.extent
					,id: this.state.id
				}).then( () => {
					this.setState({ saving: false });
				});
			} else {
				return this.context.insert({
					...values
					,extent: this.featureLayerExtent.extent
				}).then( (item) => {
					this.setState({ saving: false, id: item.id });
				});
			}
		}).then( () => {
			notification.success({
				message: 'Success',
				description: 'Project saved successfully',
				duration: 4
			});
		}).catch( (err) => {
			this.setState({ saving: false });
			if (err.message == 'NOEXTENT'){
				notification.error({
					message: 'Error',
					description: `Invalid map extent, maybe the Feature Layer URL is wrong or there was an error fetching information from ArcGIS Online. Please try updating the map extent and try again`,
					duration: 8
				});
			}
			else {
				notification.error({
					message: 'Error',
					description: `Cannot save the project. Please try again.\n${err && err.message || ''}`,
					duration: 8
				});
			}
		});
	}

	render() {
		const fields = this.state.fields;

		return (
		<>
			<Typography.Title level={3}>{ this.state.id ? 'Project detail' : 'New project' } { this.state.loading ? <Spin size="default" /> : null }</Typography.Title>
			<Card>
				<Skeleton active loading={this.state.loading} paragraph={{ rows: 4 }}>
					<ProjectDetailForm
						{...fields}
						projectId={this.state.id} saving={this.state.saving}
						onChange={this.handleFormChange} onSubmit={this.handleSubmit}
						featureLayerURLBlur={this.featureLayerURLBlur}
						extent={this.featureLayerExtent.extent}
						extentLoading={this.featureLayerExtent.loading}
						updateMapExtentButton={ 
							(<Button 
								icon="redo"
								onClick={this.refreshMapExtent}
								loading={this.featureLayerExtent.loading}>update map extent</Button>
							) }
					/>
				</Skeleton>
			</Card>
		</> );
	}
}

export { Projects, ProjectDetail };
